module.exports = __webpack_public_path__ + "static/media/test-thumb.79775bba.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/test-thumb.jpeg
// module id = 1132
// module chunks = 1